import { render, staticRenderFns } from "./IndeImg.vue?vue&type=template&id=a8b3776e&scoped=true"
import script from "./IndeImg.vue?vue&type=script&lang=js"
export * from "./IndeImg.vue?vue&type=script&lang=js"
import style0 from "./IndeImg.vue?vue&type=style&index=0&id=a8b3776e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b3776e",
  null
  
)

export default component.exports